import { h } from "../../core/dom.js";

export function devView(app) {
  const body = h("div", { class: "dev-body" });
  const element = h("section", { class: "view" }, h("h1", {}, "Area sviluppatore"), body);

  const showLogin = () => {
    const email = h("input", { type: "email", placeholder: "email", autocomplete: "email", class: "input" });
    const send = h("button", { class: "btn btn-primary wide" }, "Inviami il link di accesso");
    send.addEventListener("click", async () => {
      if (!email.value.includes("@")) return app.toast("Inserisci un'email valida", "warning");
      send.disabled = true;
      try {
        await app.dev.sendMagicLink(email.value.trim());
        body.replaceChildren(h("p", {}, "Controlla la posta e apri il link da questo dispositivo."));
      } catch (error) {
        app.reporter.report(error, "dev-login");
        app.toast("Invio non riuscito, riprova più tardi", "error");
        send.disabled = false;
      }
    });
    body.replaceChildren(email, send);
  };

  const showInfo = (info) => {
    const rows = [
      ["Versione", `${info.versionName} (${info.versionCode})`],
      ["Versione hex", info.versionHex],
      ["Commit", info.commit],
      ["Ultimo aggiornamento", info.buildDateLocal],
      ["Modello", app.classifier.metadata?.model_version || "-"],
      ["Architettura", app.classifier.metadata?.architecture || "-"]
    ];
    body.replaceChildren(
      h("dl", { class: "dev-grid" }, rows.flatMap(([k, v]) => [h("dt", {}, k), h("dd", {}, h("code", {}, v || "-"))])),
      h("button", { class: "btn btn-ghost wide", onclick: async () => { await app.dev.signOut(); showLogin(); } }, "Esci"));
  };

  const mount = async () => {
    if (!app.dev.configured) {
      body.replaceChildren(h("p", { class: "muted" }, "Accesso non disponibile."));
      return;
    }
    body.replaceChildren(h("p", { class: "muted" }, "Verifico…"));
    try {
      const info = await app.dev.buildInfo();
      if (info) showInfo(info);
      else showLogin();
    } catch (error) {
      if (error.status === 403) {
        body.replaceChildren(h("p", {}, "Questo account non ha accesso all'area sviluppatore."),
          h("button", { class: "btn btn-ghost wide", onclick: async () => { await app.dev.signOut(); showLogin(); } }, "Esci"));
      } else {
        app.reporter.report(error, "dev-info");
        showLogin();
      }
    }
  };
  return { element, mount };
}
